import React from 'react';
import Icon from '../../../components/AppIcon';

const SkillGapAnalysis = ({ skillGaps }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-warning/10 rounded-lg flex items-center justify-center">
          <Icon name="Target" size={20} className="text-warning" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-text-primary">Skill Gap Analysis</h3>
          <p className="text-sm text-text-secondary">Areas for improvement and development</p>
        </div>
      </div>
      <div className="space-y-4">
        {skillGaps?.map((gap, index) => (
          <div key={index} className="border border-border rounded-lg p-4">
            <div className="flex items-center justify-between mb-3">
              <h4 className="font-medium text-text-primary">{gap?.skill}</h4>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                gap?.priority === 'High' ? 'bg-error/10 text-error' :
                gap?.priority === 'Medium'? 'bg-warning/10 text-warning' : 'bg-muted text-text-secondary'
              }`}>
                {gap?.priority} Priority
              </span>
            </div>
            <p className="text-sm text-text-secondary mb-3">{gap?.description}</p>
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2">
                <span className="text-xs text-text-secondary">Current Level:</span>
                <div className="flex-1 bg-muted rounded-full h-1.5 w-20">
                  <div 
                    className="bg-primary h-1.5 rounded-full"
                    style={{ width: `${gap?.currentLevel}%` }}
                  ></div>
                </div>
                <span className="text-xs font-medium">{gap?.currentLevel}%</span>
              </div>
              <div className="flex items-center space-x-2">
                <span className="text-xs text-text-secondary">Target:</span>
                <span className="text-xs font-medium text-success">{gap?.targetLevel}%</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkillGapAnalysis;